import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import ServiceProcess from './components/ServiceProcess';
import CaseStudies from './components/CaseStudies';
import Partners from './components/Partners';
import About from './components/About';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Solutions />
      <ServiceProcess />
      <CaseStudies />
      <Partners />
      <About />
      <Footer />
    </div>
  );
}
